import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';



class ListaPropostasPJ extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: '',
      apiPage: null,
      data: 'loading',
      showTable: false,
      showColBroker: false,
      showColSalesman: false,
      showColStage: false,

      tablePageStart: '',
      tablePageEnd: '',
      tablePageTotal: '',
    };

    this.errorField = {
      
    };

    this.errorFormat = {
      
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      inputSearch: {
        marginLeft: 8,
        flex: 1,
      },
      theadTh:{
        height: 40,
      },
      tdDate: {
        color: 'rgb(117, 117, 117)',
        margin: 0,
        fontSize: 11,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        lineHeight: '13px',
        letterSpacing: '0.33px',
        textTransform: 'uppercase',
        padding: 0,
        height: 40,
      }
    }

  }


  componentDidMount() {
    let userType = localStorage.getItem('planos_y');
    let state = this.state;

    // Verifica se exibe ou não a coluna 'Corretora'
    /* if (userType !== 'SALESMAN' && userType !== 'BROKER')
      state.showColBroker = true;
    else
      state.showColBroker = false; */

    // Verifica se exibe ou não a coluna 'Vendedor'
    if (userType === 'SALESMAN')
      state.showColSalesman = false;
    else
      state.showColSalesman = true;

    this.setState(state);
  
    this.getFilterName();
    this.getData(true);
  }

  getFilterName() {
    // pega o filtro para saber q nome exibir no titulo
    let state = this.state;
    let page = this.props.history.location.pathname;

    page = page.split('/');
    page = page[page.length - 1];

    state.page = page;

    if (page === "geralpj") {
      state.titlePage = "TODAS AS PROPOSTAS - PJ";
      state.apiPage = 'all';
    }
    else if (page === "pendentespj") {
      state.titlePage = configBase.statusPendente;
      state.apiPage = 'pjawaitingpayment';
    }
    else if (page === "confpendentespj") {
      state.titlePage = configBase.statusConfPendentePJ;
      state.apiPage = 'pjconfirmation';
    }
    else if (page === "emprocessamentopj") {
      state.titlePage = configBase.statusEmProcessamentoPJ;
      state.apiPage = 'pjprocessing';
    }
    else if (page === "indeferidaspj") {
      state.titlePage = configBase.statusIndeferidaPJ;
      state.apiPage = 'pjpending';
    }
    else if (page === "emanalisepj") {
      state.titlePage = configBase.statusEmAnalisePJ;
      state.apiPage = 'pjinvalidation';
    }
    else if (page === "implantadaspj") {
      state.titlePage = configBase.statusImplementadasPJ;
      state.apiPage = 'pjdeployed60days';
    }
    else if (page === "canceladaspj") {
      state.titlePage = configBase.statusCanceladasPJ;
      state.apiPage = 'pjcanceled60days';
    }
    else 
      state.titlePage = "PÁGINA INCORRETA";
      

    this.setState(state);
  }

  getData(table=false) {
    // Para o tipo dos dados da tabela
    let typeBox = this.state.apiPage;

    if (typeBox === null) {
      let state = this.state;
      state.data = 'zero';
      this.setState(state);
    }
    else {
      let dataPost = {
        user: localStorage.getItem('planos_u'),
        content: typeBox,
      };
      let url = configBase.api + 'Companies/listByUser?access_token='+localStorage.getItem('planos_t');

      axios.post(url, dataPost)
      .then((response) => {

        let state = this.state;

        // Verifica o vendedor padrão
        if (response.data.salesmanDefault && response.data.salesmanDefault === true)
          state.showColSalesman = true;

        if (response.data.companys.length > 0) {
          state.data = response.data;
          this.setState(state);
          this.setColorStatus(response.data.companys);
        }
        else {
          state.data = 'zero';
          this.setState(state);
        }

        if (table === true && state.showTable === false) {
          state.showTable = true;
          this.setState(state);

          $(document).ready( function () {
            let table = $('#table_id').DataTable({
              "dom": 'rtip',// Exibe {processing}{table}{information}{pagination}
              "language": {
                "url": `${process.env.PUBLIC_URL}/plugins/datatables/Portuguese-Brasil.lang`
              },
              "order": [[0, "desc"]],
              columnDefs: [
                { type: 'date-uk', targets: 0 },
              ],
              "infoCallback": function( settings, start, end, max, total, pre ) {// Quantidade por página
                document.getElementById('tablePageStart').innerHTML = start;
                document.getElementById('tablePageEnd').innerHTML = end;
                document.getElementById('tablePageTotal').innerHTML = total;
                return '';
              },
              pagingType: "simple",
              oLanguage: {
                oPaginate: {
                  sNext: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path></svg>',
                  sPrevious: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>'
                },
              },
              "scrollX": true,
            });

            $('#mySearchText').on( 'keyup', function () {
              table.search($('#mySearchText').val()).draw();
            } );

            // Quantidade por página
            $('#myLengthMenu').on( 'change', function () {
              table.page.len($('#myLengthMenu').val()).draw();
            } );

            $.extend( $.fn.dataTableExt.oSort, {
              "date-uk-pre": function ( a ) {
                if (a === null || a === "") {
                  return 0;
                }
                var ukDatea = a.split('/');
                return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
              },
            
              "date-uk-asc": function ( a, b ) {
                return ((a < b) ? -1 : ((a > b) ? 1 : 0));
              },
            
              "date-uk-desc": function ( a, b ) {
                return ((a < b) ? 1 : ((a > b) ? -1 : 0));
              }
            } );
          });
        }
      })
      .catch(function () {
        let state = this.state;
        state.data = 'error';
        this.setState(state);
      }.bind(this));
    }

  }

  setColorStatus(companys) {
    let colors = {
      'AGUARDANDO PAGAMENTO': {color: configBase.bgPendentePJ, name: configBase.statusPendentePJ},
      'AGUARDANDO CONFIRMAÇÃO': {color: configBase.bgConfPendentePJ, name: configBase.statusConfPendentePJ},
      'EM PROCESSAMENTO': {color: configBase.bgEmProcessamentoPJ, name: configBase.statusEmProcessamentoPJ},
      'EM VALIDAÇÃO': {color: configBase.bgEmAnalisePJ, name: configBase.statusEmAnalisePJ},
      'PENDENTE': {color: configBase.bgIndeferidaPJ, name: configBase.statusIndeferidaPJ},
      'CANCELADO': {color: configBase.bgCanceladasPJ, name: configBase.statusCanceladasPJ},
      'ATIVO': {color: configBase.bgImplementadasPJ, name: configBase.statusImplementadasPJ},
    };
    let state = this.state;

    for (let i = 0; i < companys.length; i++) {
      companys[i].color = colors[companys[i].status].color;
      companys[i].status = colors[companys[i].status].name;
    }

    state.data.companys = companys;
    this.setState(state)
  }

  sendDetails(companyId) {
    if (companyId != null) {
      this.props.history.push(`${process.env.PUBLIC_URL}/resumopj?p=${companyId}`);
    }
  }

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="listaPropostas" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              {this.state.titlePage}
            </Typography>
          </Paper>

          <div id="listaPropostaConteudo" className="contentepanel">
          {
          this.state.data === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO PROPOSTAS...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.data === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar lista de propostas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.data === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="listaPropostaTabela">
              {/* ############# CSS PARA DATATABLE ############# */}
              <link
                rel="stylesheet" type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
              />
              <link
                rel="stylesheet" type="text/css"
                href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
              />
              {/* ############# CSS PARA DATATABLE ############# */}

              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} style={{marginBottom: 20}}>
                  <Paper elevation={1}>
                    <IconButton style={{padding: '6px 5px'}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      id="mySearchText"
                      style={this.styles.inputSearch}
                      placeholder="Pesquisar"
                      inputProps={{ 'aria-label': 'search google maps' }}
                    />
                  </Paper>
                </Grid>
              </Grid>

              <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                  <tr style={this.styles.theadTr}>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        Data
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        Empresa
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        CNPJ
                      </Typography>
                    </th>
                    {
                      this.state.showColSalesman === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        Vendedor
                      </Typography>
                    </th>
                      )
                    }
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        Vidas
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        Valor
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        Status
                      </Typography>
                    </th>
                  </tr>
                </thead>

                <tbody>
                {this.state.data.companys.map((item, index) =>
                  <tr
                    id={'row_sales_'+item.salesId}
                    key={index}
                    className="row_table"
                    onClick={this.sendDetails.bind(this, item.id)}
                    style={{cursor:'pointer', height: 40, padding: 0}}
                  >
                    <td style={this.styles.tdDate}>
                      {item.dateFormat}
                    </td>

                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {item.fantasyName}
                      </Typography>
                    </td>

                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {item.cnpj}
                      </Typography>
                    </td>

                    {
                      this.state.showColSalesman === true && (
                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {item.salesman}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {item.lives}
                      </Typography>
                    </td>

                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        R$ {item.value}
                      </Typography>
                    </td>

                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        <span
                          style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}
                        >
                          {item.status}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                )}
                </tbody>
              </table>

              <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                  <label htmlFor="myLengthMenu">Linhas por página: </label>
                  <select id="myLengthMenu" style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    {/* <option value="-1">Todas</option> */}
                  </select>
                  <span id="tablePageStart" style={{marginLeft: 15}}></span>-<span id="tablePageEnd"></span>
                  {' '}de{' '}
                  <span id="tablePageTotal"></span>
                </div>
              </div>

            </div>
              )
              )
            )
          }
          </div>
        </div>
      </MainLayout>
    );

  }

}

ListaPropostasPJ.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasPJ);